import { createTheme } from '@mui/material';

import { MAIN_BODY_FONT, MAIN_TITLE_FONT } from './variables';

import * as colors from './colors';

const interFontFamily = { fontFamily: MAIN_BODY_FONT };

const stabilFontFamily = { fontFamily: MAIN_TITLE_FONT };

const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: colors.BRAND_COLOR,
      dark: colors.ACCENT,
      light: colors.SECONDARY_DISABLED,
      contrastText: colors.HEADER_TEXT,
    },
    secondary: {
      main: colors.NAV_BG_COLOR,
      contrastText: colors.SUB_TITLE_COLOR,
      light: colors.SECONDARY,
      dark: colors.BORDER_COLOR,
    },
    background: {
      default: colors.LAYOUT_BG_COLOR,
      paper: colors.NAV_BG_COLOR,
    },
    success: {
      main: colors.SUCCESS,
      dark: colors.SUCCESS_ACCENT,
      light: colors.ICONS,
    },
    error: {
      main: colors.ERROR,
      dark: colors.ERROR_ACCENT,
    },
    warning: {
      main: colors.WARNING,
      dark: colors.WARNING_ACCENT,
      light: colors.PILL_1,
    },
    info: {
      main: colors.INFO,
      light: colors.INFO_ACCENT,
      dark: colors.DIVIDER,
      contrastText: colors.BORDER_HIGH_LIGHT,
    },
    text: {
      primary: colors.BODY_COLOR,
      secondary: colors.TITLE_COLOR,
      disabled: colors.SUB_TITLE_COLOR,
    },
    grey: {
      500: colors.BG_AVATAR,
      600: colors.LIGHT_GRAY,
    },
  },
  typography: {
    fontFamily: ['Inter', 'StabilGrotesk', 'sans-serif'].join(','),
    h1: stabilFontFamily,
    h2: {
      ...stabilFontFamily,
      color: colors.TITLE_COLOR,
      fontSize: '36px',
      fontWeight: 'bold',
    },
    h3: stabilFontFamily,
    h4: stabilFontFamily,
    h5: stabilFontFamily,
    h6: stabilFontFamily,
    body1: interFontFamily,
    body2: interFontFamily,
    subtitle1: {
      ...interFontFamily,
      color: colors.SUB_TITLE_COLOR,
      fontSize: '18px',
      fontWeight: 'bold',
      margin: '8px 0',
    },
    subtitle2: {
      ...interFontFamily,
      color: '#404547',
      fontSize: '14px',
      fontWeight: '600',
      lineHeight: '24px',
    },
    button: interFontFamily,
    caption: {
      ...interFontFamily,
      fontSize: '14px',
      lineHeight: '20px',
      color: '#757A7D',
    },
    overline: interFontFamily,
  },
});

export { lightTheme };
